import commonMixin from '../../../mixins/_common';
import flashMessageMixin from '../../../mixins/_flash_messages';
import partsMixin from '../_parts_mixin';
import modalMixin from '@/mixins/_modal';
import loop from '../../../components/_loop-component';
import { eventBus } from '@/helpers/_event_bus';

// 商品パーツのラベル一覧
const ITEM_LABEL_PATH = 'common/parts/item_label/magnet_lb_';
const ITEM_LABELS = [
    'new1.png',
    'new2.png',
    'new_l.png',
    'restock1.png',
    'restock2.png',
    'restock_l.png',
    'rc1.png',
    'rc2.png',
    'pick.png',
    'hit1.png',
    'hit2.png',
    'gift1.png',
    'gift2.png',
    'gift3.png',
    'gift4.png',
    'gift5.png',
    'gift6.png',
    'sale1.png',
    'sale2.png',
    'sale3.png',
    'sale4.png',
    'paypay.png',
    'paypay_b.png',
    'sale10.png',
    'sale20.png',
    'sale30.png',
    'sale40.png',
    'sale50.png',
    'sale_l.png',
    'fs1.png',
    'fs2.png',
    'fs3.png',
    'point1.png',
    'baibai.png',
    'baibai_2.png',
    'baibai_3.png',
    'point_5bai.png',
    'point_10bai.png',
    'coupon1.png',
    'coupon2.png',
    'coupon_l.png',
    'limit.png',
    'so.png',
    'so2.png',
    'backorder.png',
    'reserve.png',
    'only.png',
    'handmade.png',
    'name.png',
    'set.png',
    'keirou.png',
    'halloween.png',
    'xmas.png',
    'celebrate.png',
    'celebrate2.png',
    'ochugen.png',
    'oseibo.png',
    'spring.png',
    'summer.png',
    'autumn.png',
    'winter.png',
    'valentine.png',
    'whiteday.png',
    'newlife.png',
    'mothersday.png',
    'fathersday.png',
];

// 商品パーツの看板一覧
const ITEM_KANBAN_PATH = 'common/parts/item_kanban/magnet_kb_';
const ITEM_KANBANS = [
    'paypay_202507.png',
    'fathersday.png',
    'fathersday2.png',
    'st_new.png',
    'st_rl.png',
    'st_rc.png',
    'st_sale.png',
    'st_free.png',
    'jewerly_new.png',
    'jewerly_sale.png',
    'jewerly_free.png',
    'jewerly_point.png',
    'jewerly_hot.png',
    'jewerly_coupon.png',
    'apy_new.png',
    'apy_sale.png',
    'apy_free.png',
    'apy_point.png',
    'apy_hot.png',
    'apy_coupon.png',
    'freeshipping.png',
    'buybuy5.png',
    'buybuy10.png',
    'gooddelivery.png',
    'keirou.png',
    'valentine.png',
    'valentine2.png',
    'valentine3.png',
    'summergift.png',
    'christmassale.png',
    'thankssale.png',
    'newyearsale.png',
    'whiteday1.png',
    'whiteday2.png',
    'mothersday.png',
];

// 商品パーツデザインパターン一覧
const ITEM_DESING_PATTERN_PATH = 'common/parts/item_design/';
const ITEM_DESING_PATTERN = [
    'default',
    'rounded',
    'shadow',
    'snapp',
    'row',
    'row_snapp',
    'circle'
];

/**
 * パーツ編集コンポーネント「商品パーツ」
 */
export default {
    template: '#parts_edit_item_template',
    data() {
        return {
            // 変更対象itemIndex
            targetItemIndex: 0,
            // デザイン設定
            designPatternPath: ITEM_DESING_PATTERN_PATH,
            designPattern: ITEM_DESING_PATTERN,
            shouldUpdateAllItems: false,
        };
    },
    props: [
        'parts_data',
        'type',
        'edit_id',
        'device_sync',
    ],
    mixins: [commonMixin, flashMessageMixin, partsMixin, modalMixin],
    created: function () {
        // イベントバスで商品選択結果を受け取る
        const resultFor = 'result_for_' + this.componentId;
        eventBus.$on(resultFor, (item, mode) => {
            if (mode === 'normal') {
                this.selectedItem(item);
            } else if (mode === 'multiple') {
                this.selectedItems(item);
            }
        });
    },
    computed: {
        itemLabels: function () {
            let labels = [null];
            for (const i in ITEM_LABELS) {
                labels.push(ITEM_LABEL_PATH + ITEM_LABELS[i]);
            }
            return labels;
        },
        itemKanbans: function () {
            let kanbans = [null];
            for (const i in ITEM_KANBANS) {
                kanbans.push(ITEM_KANBAN_PATH + ITEM_KANBANS[i]);
            }
            return kanbans;
        },
        isSelectItem: function () {
            return this.parts_data?.main.length > 0;
        }
    },
    components: {
        'loop': loop,
    },
    watch: {
        ['parts_data.show_normal_price']: function (shouldShow) {
            if(!shouldShow) {
                this.parts_data.show_sale_price = false;
            }
        },
    },
    emits: [
        'update:parts_data',
        'bulk-update-all-items',
    ],
    methods: {
        // 商品選択モーダルをイベントバス経由で開く
        openItemSearch: function (mode, position) {
            if (mode === 'normal') {
                eventBus.$emit('open_modal_item_search', {
                    'from': this.componentId,
                    'mode': mode
                });
            } else if (mode === 'multiple') {
                eventBus.$emit('open_modal_item_search', {
                    'from': this.componentId,
                    'mode': mode,
                    'add_position': position,
                    'selected_item': this.parts_data.main
                });
            }
        },
        // 商品を個別にクリック時
        changeItem: function (index) {
            // 変更対象itemのindexを保持
            this.targetItemIndex = index;
            // 商品検索コンポーネントを開く
            this.openItemSearch('normal');
        },
        // 商品選択結果(一つ)をパーツへ反映
        selectedItem: function (item) {
            // ItemURLを相対パスにする
            item.item_url = this.changeItemUrltoRelative(item);
            // item差し替え
            this.$refs.loop.replace(this.targetItemIndex, item);
        },
        // 商品選択結果(複数)をパーツへ反映
        selectedItems: function (items) {
            // ItemURLを相対パスにする
            items.forEach(function (item) {
                item.item_url = this.changeItemUrltoRelative(item);
            }, this);
            this.parts_data.main = items;
        },
        // ItemURLを相対パスにする
        // (2022年4月21日〜Yahoo!側で「/」開始の相対パスが除去対象になったため、「//」からの相対パスに変更)
        // (2022年9月20日〜Android端末を考慮して相対パスから絶対パスに変更)
        changeItemUrltoRelative: function (item) {
            return 'https://store.shopping.yahoo.co.jp/' + this.config.user.shop_id + '/' + item.item_code;
        },
        // 商品最新化処理
        updateItems: async function () {
            if (this.shouldUpdateAllItems) {
                this.$emit('bulk-update-all-items');
            } else {
                this.getItems();
            }
            this.close();
        },
        // 現在選択中の商品の最新情報の取得処理
        getItems: async function () {
            let message = this.exception_error_message;
            this.$_loading();

            let data = [];
            for (let i in this.parts_data.main) {
                data[i] = this.parts_data.main[i];
                let item_code = this.parts_data.main[i].item_code;
                if (item_code) {
                    await axios.get('/search_items', {
                        params: {
                            hits: 100,
                            page: 1,
                            keyword: item_code,
                            stock_flag: 'all_items',
                            not_keyword: '',
                            min_price: '',
                            max_price: '',
                            search_mode: 'item_code',
                            page_key: '',
                            sort: '',
                            add_tax: '1',
                            is_item_update: '1'
                        }
                    }).then((response) => {
                        if (response.data.status === 'OK') {
                            let items = response.data.data.items;
                            if (items.length > 0) {
                                items.forEach(function (item) {
                                    if (item.item_code == item_code) {
                                        data[i] = item;
                                        return false;
                                    }
                                }, this);
                            }
                            message = '';
                        } else {
                            message = response.data.message;
                        }
                    }).catch((error) => {
                        message = this.getCatchMessage(error);
                    });
                }
            }

            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            } else {
                this.clearFlashMessage(null, this.$parent);
            }

            this.parts_data.main = data;
            this.$emit('update:parts_data', this.parts_data);

            this.$_unloading();
        }
    }
};
